import { IconButton } from "@maxhub/max-ui";
import { ArrowBack } from "../icons/icons.tsx";
import "./AppHeader.css";

type AppHeaderProps = {
  onClickHandler: () => void;
};

export const AppHeader = ({ onClickHandler }: AppHeaderProps) => {
  return (
    <div className={"app-header"}>
      <IconButton
        mode="secondary"
        appearance="neutral"
        className={"button-before"}
        size={"medium"}
        onClick={onClickHandler}
      >
        <ArrowBack className={"button-img"} />
      </IconButton>
    </div>
  );
};
